module.exports = __webpack_public_path__ + "static/media/register-form.3ba99eab.png";